import { type QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import * as Sentry from "@sentry/react";
// import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
// import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import { Toaster } from "@/components/ui/sonner";
import { NavigationProgress } from "@/components/navigation-progress";
import { GeneralError } from "@/features/errors/general-error";
import { NotFoundError } from "@/features/errors/not-found-error";
import { useVersionCheck } from "@/hooks/use-version-check";

function RootComponent() {
  useVersionCheck();

  return (
    <>
      <NavigationProgress />
      <Outlet />
      <Toaster duration={5000} />
      {import.meta.env.MODE === "development" && (
        <>
          {/* <ReactQueryDevtools buttonPosition="bottom-left" /> */}
          {/* <TanStackRouterDevtools position="bottom-right" /> */}
        </>
      )}
    </>
  );
}

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient;
}>()({
  component: RootComponent,
  notFoundComponent: NotFoundError,
  errorComponent: ({ error }) => {
    // Report router-level errors immediately to ensure they're captured
    // This catches errors before they potentially bypass AppErrorBoundary
    if (import.meta.env.VITE_SENTRY_DSN) {
      Sentry.captureException(error, {
        tags: {
          context: "root-error-component",
          errorType: "router-level",
        },
        extra: {
          url: window.location.href,
          timestamp: new Date().toISOString(),
        },
      });
    }

    return <GeneralError error={error} />;
  },
});
